import React, { Component } from 'react';
// import { Button, Col, Container, Form, FormGroup, Input, Row, Table } from 'reactstrap';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import configData from '../config.json';

export default class VerteilungListe extends Component {
    
    constructor(props) {
        super(props);
    
        this.state = {
            artikelList: [],
            artikelInfo: [],
            exTools: null,
            token: null,
            artKlasse: '',
            artSearch: '',
            artStart: 0,
            artLimit: 18
        }

        this.token = null;
        this.artKlasse = '';
        this.artSearch = '';
        this.body = '';
        this.artGroup = null;
        this.onChangeArtKlasse = this.onChangeArtKlasse.bind(this);
        this.onChangeSearch = this.onChangeSearch.bind(this);
        this.onClickX = this.onClickX.bind(this);
    }

    _fetchData = async () => {
        var body = '';
        var sbody = 'params[filiale]=' + sessionStorage.getItem('filiale');
        var ebody = '';
        
        body += `&params[klasse]=` + this.state.artKlasse;
        if(this.state.artSearch !== '') {
            body += `&params[search]=` + this.state.artSearch;
        }
        body += `&params[verteilung]=20`;// + this.state.artStart;
        body += `&params[start]=` + this.state.artStart;
        body += `&params[limit]=` + this.state.artLimit;

        //console.log('body', body);

        ebody += "&token=" + this.token;

        if(body !== this.body && this.state.artKlasse !== '') {
            this.body = body;
            const response = await fetch(configData.SERVER_URL + 'artikel', {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },            
                method: 'POST',
                body: sbody + body + ebody,
            });
            const responseJson = await response.json();
            //console.log(responseJson.status);
            if(responseJson.status === true) {
                this.props.onSetTimer(responseJson.user.TOKEN_TIME);
                this.setState({ 
                    artikelList: responseJson.data.artikel, 
                    artikelInfo: responseJson.data.info,
                });
            } else {
                this.onClickExit();
            }
        }

    };

    onChangeArtKlasse(event) {
        this.setState({
            artKlasse: event.target.value, 
            artSearch: '',
            artStart: 0,
            artLimit: 18
        });
    }

    onChangeSearch(event) {
        this.setState({artSearch: event.target.value});
    }

    onClickX(event) {
        //console.log('onClickX', event.target.value);
        this.setState({artStart: event.target.value});
    }

    onClickExit() {
        sessionStorage.clear();
        window.location.reload(false);
    }    

    componentDidUpdate() {
       this._fetchData();
    }

    componentDidMount() {
        if(sessionStorage.getItem('exTools')) {
            const response = sessionStorage.getItem('exTools');
            const responseJson = JSON.parse(response);
            //console.log('DidMount AusstellerList', responseJson.Ergebnis);
            if(responseJson.Ergebnis !== 'undefined') {
                this.token = responseJson.Ergebnis;
            }
        }
        this._fetchData();
    }

    render() {
        //console.log('renderInfo', this.state.artikelInfo);
        //console.log('renderListe', this.state.artikelList);

        let backButton, fwdButton, infoAll, cssFiliale1, cssFiliale2, cssFiliale3, cssFiliale4;

        if(this.state.artikelInfo.back !== false) {
            backButton = <Button onClick={this.onClickX} value={this.state.artikelInfo.back}>zurück</Button>;
        } else {
            backButton = '';
        }
        if(this.state.artikelInfo.all === '0') {
            infoAll = '';
        } else {
            infoAll = this.state.artikelInfo.info;
        }
        if(this.state.artikelInfo.fwd !== false) {
            fwdButton = <Button onClick={this.onClickX} value={this.state.artikelInfo.fwd}>weiter</Button>;
        } else {
            fwdButton = '';
        }

        if(sessionStorage.getItem('filiale')*1 === 1) {
            cssFiliale1 = {textAlign: "center", color: "blue"};
        } else {
            cssFiliale1 = {textAlign: "center"};
        }
        if(sessionStorage.getItem('filiale')*1 === 2) {
            cssFiliale2 = {textAlign: "center", color: "blue"};            
        } else {
            cssFiliale2 = {textAlign: "center"};
        }
        if(sessionStorage.getItem('filiale')*1 === 3) {
            cssFiliale3 = {textAlign: "center", color: "blue"};
        } else {
            cssFiliale3 = {textAlign: "center"};
        }
        if(sessionStorage.getItem('filiale')*1 === 4) {
            cssFiliale4 = {textAlign: "center", color: "blue"};
        } else {
            cssFiliale4 = {textAlign: "center"};
        }
            return(
                <Container fluid style={{padding: "4rem 0px 0px 0px"}}>
                    <Form inline>
                        <Row>
                            <Col>
                                <Form.Group>
                                    <Form.Select
                                    id="selectWarengruppe"
                                    name="filiale"
                                    type="select"
                                    onChange={this.onChangeArtKlasse}
                                    defaultValue={this.state.artKlasse}
                                    >
                                        <option>bitte wählen</option>
                                        <option value="11,12,13,14">11..14 BW</option>
                                        <option value="15,16">15..16 TK</option>
                                        <option value="17,18,19">17..19 PC</option>
                                        <option value="20,21,22,23,24,25,26,27,28,29">2</option>
                                        <option value="30,31,32,33,34,35">30..35 WW Groß</option>
                                        <option value="36,37,38,39">36..39 WW Klein</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group>
                                    <Form.Control
                                        id="exampleEmail"
                                        name="search"
                                        placeholder="suche"
                                        type="text"
                                        onChange={this.onChangeSearch}
                                        value={this.state.artSearch}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Form>
                    <Table hover striped>
                        <thead>
                            <tr>
                                <th rowSpan='2'>Nr</th>
                                <th rowSpan='2'>Bezeichnung</th>
                                <th colSpan='5' style={{textAlign: "center"}}>Bestand</th>
                            </tr>
                            <tr>
                                <th style={{textAlign: "center"}}>Ges</th>
                                <th style={cssFiliale1}>01</th>
                                <th style={cssFiliale2}>02</th>
                                <th style={cssFiliale3}>03</th>
                                <th style={cssFiliale4}>04</th>
                            </tr>                        
                        </thead>
                        <tbody>
                            {
                                this.state.artikelList.map((element, index) => {
                                    return (
                                        <tr>
                                            <td>{element.artnr}</td>
                                            <td>{element.bezeichnung}</td>
                                            <td style={{textAlign: "center"}}>{element.gesBestandMg}</td>
                                            <td style={cssFiliale1}>{element.filialdata[0].bestandMg}</td>
                                            <td style={cssFiliale2}>{element.filialdata[1].bestandMg}</td>
                                            <td style={cssFiliale3}>{element.filialdata[2].bestandMg}</td>
                                            <td style={cssFiliale4}>{element.filialdata[3].bestandMg}</td>
                                        </tr>
                                        //<ModalAussteller key={index} element={element} elementFil={element.filialdata} token={this.token} onUpdateData={this._fetchData} />
                                    );
    
                                })
                            }
                        </tbody>
                    </Table>
                        <Row>
                            <Col>{backButton}</Col>
                            <Col style={{textAlign: "center"}}>{infoAll}</Col>
                            <Col style={{textAlign: "right"}}>{fwdButton}</Col>
                        </Row>
                </Container>
            );
        

    }
}
